import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useMemo, useCallback, useState } from 'react';
import CTA from "../CTA/CTA";
import { Filters } from "../../Constants/filters";
var css = {
  "priceEmiTabContainer": "oalp-3Vca8",
  "tabsContainer": "oalp-2rzOG",
  "tabBtnStyle": "oalp-CFVoC",
  "selectedTabBtnStyle": "oalp-uc4dn",
  "title": "oalp-EgYZ1"
};
import EqualWidthColumnStaticContent from "../../Widgets/EqualWidthColumnStaticContent/EqualWidthColumnStaticContent";
import { selectedCardStyle, cardStyle, equalWidthColumnMetadata, disabledCardStyle } from "../../Constants/buyerIntent";
import { EQUAL_WIDTH_COLUMN_STATIC_CONTENT } from "../../Constants/templateName";
export var PriceEmi = function PriceEmi(_ref) {
  var _ref$subStep = _ref.subStep,
    subStep = _ref$subStep === void 0 ? Filters.price : _ref$subStep,
    _ref$tabsButtons = _ref.tabsButtons,
    tabsButtons = _ref$tabsButtons === void 0 ? [] : _ref$tabsButtons,
    content = _ref.content,
    handleFilterClick = _ref.handleFilterClick,
    setSubStep = _ref.setSubStep,
    discardAllFilters = _ref.discardAllFilters,
    tabTitle = _ref.tabTitle,
    _ref$widgetKey = _ref.widgetKey,
    widgetKey = _ref$widgetKey === void 0 ? '' : _ref$widgetKey;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    selectedCardId = _useState2[0],
    setSelectedCardId = _useState2[1];
  var onTabClickHandler = useCallback(function () {
    discardAllFilters();
    setSelectedCardId('');
    setSubStep(subStep == Filters.price ? Filters.emi : Filters.price);
  }, [discardAllFilters, setSubStep, subStep]);
  var price = content.price,
    emi = content.emi;
  var list = useMemo(function () {
    return (subStep === Filters.price ? price : emi) || [];
  }, [emi, price, subStep]);
  var parsedData = useMemo(function () {
    if (Array.isArray(list)) {
      return list.map(function (_ref2) {
        var name = _ref2.name,
          id = _ref2.id,
          count = _ref2.count;
        var style = {};
        if (count === 0) {
          style = disabledCardStyle;
        } else {
          style = id === selectedCardId ? selectedCardStyle : cardStyle;
        }
        return {
          title: {
            text: name,
            style: style
          }
        };
      });
    }
    return [];
  }, [list, selectedCardId]);
  function onCardClickHandler(event) {
    var index = event.currentTarget.getAttribute('data-index');
    if (index) {
      var filter = list[parseInt(index, 10)];
      var _filter$count = filter.count,
        count = _filter$count === void 0 ? 0 : _filter$count;
      if (count !== 0) {
        handleFilterClick(filter);
        setSelectedCardId(filter.id);
      }
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    className: css.container
  }, tabsButtons.length > 1 && /*#__PURE__*/React.createElement("div", {
    className: css.priceEmiTabContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: css.tabsContainer
  }, tabsButtons.map(function (tab) {
    return /*#__PURE__*/React.createElement(CTA, {
      key: tab.name,
      button: tab,
      handleOnClick: onTabClickHandler,
      customClass: subStep === tab.name ? css.selectedTabBtnStyle : css.tabBtnStyle,
      widgetKey: widgetKey
    });
  }))), tabTitle && /*#__PURE__*/React.createElement("div", {
    className: css.title
  }, tabTitle), /*#__PURE__*/React.createElement(EqualWidthColumnStaticContent, {
    name: EQUAL_WIDTH_COLUMN_STATIC_CONTENT,
    templateName: EQUAL_WIDTH_COLUMN_STATIC_CONTENT,
    metadata: equalWidthColumnMetadata,
    data: parsedData,
    handleClick: onCardClickHandler,
    showObserver: false
  }));
};
export default PriceEmi;